import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  inject,
} from '@angular/core';

@Directive({
  selector: '[bshResizeObserver]',
})
export class ResizeObserverDirective implements OnDestroy {
  #el = inject(ElementRef);
  private readonly observer: ResizeObserver;

  @Output() resized = new EventEmitter<DOMRectReadOnly>();

  constructor() {
    this.observer = new ResizeObserver(entries => {
      this.resized.emit(entries[0].contentRect);
    });
    this.observer.observe(this.#el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.unobserve(this.#el.nativeElement);
    this.observer.disconnect();
  }
}
